export const UK = "GB";
export const ESTABLISHMENT = "establishment";
export const HOSPITAL = "hospital";
export const ADDRESS = "address";